import { List, ListItemButton, ListItemText, Typography } from '@mui/material'
import type { SpaceGqlModel } from '../gql/SpaceGqlModel'
import { CreateSpacePanel } from './CreateSpacePanel.tsx'
import { useContext, useState } from 'react'
import { ModalContext } from '../../core/modal/ModalContext.tsx'
import type { OperationResult } from '@/common/errors/OperationResult'
import './SpaceSelectPanel.css'
import { SpaceOptionsPopoverItems } from './SpaceOptionsPopoverItems.tsx'
import { useOptionsPopover } from '../../core/popover/popover-hooks.tsx'
import { DefaultPopover } from '../../core/popover/DefaultPopover.tsx'
import { PopoverOptionsMenuIcon } from '@/core/popover/options/PopoverOptionsMenuIcon.tsx'

interface SelectSpacePanelProps {
  selectedSpace: SpaceGqlModel
  spaces: SpaceGqlModel[]
  onSpaceSelected: (selectedSpace: SpaceGqlModel) => void
}

export function SelectSpacePanel({
  selectedSpace,
  spaces,
  onSpaceSelected,
}: SelectSpacePanelProps) {
  const { openModal } = useContext(ModalContext)!
  const { anchorEl, openPopover, closePopover } = useOptionsPopover()
  const [hoveredSpace, setHoveredSpace] = useState<SpaceGqlModel | undefined>(undefined)
  const canDelete = spaces.length > 1

  async function handleCreateNewSpaceAsync() {
    await openModal<OperationResult<SpaceGqlModel | undefined>>((modalProps) => (
      <CreateSpacePanel {...modalProps} />
    ))
  }
  return (
    <>
      <List data-testid="SpaceSelectPanel">
        {spaces.map((space) => (
          <ListItemButton
            className="spaceListItem"
            key={space.id}
            selected={space === selectedSpace}
            onClick={() => onSpaceSelected(space)}
          >
            <ListItemText className="spaceName" primary={space.name} />
            <PopoverOptionsMenuIcon
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation()
                openPopover(e.currentTarget)
                setHoveredSpace(space)
              }}
            />
          </ListItemButton>
        ))}
        <ListItemButton
          data-testid="new-space-button"
          onClick={() => {
            void handleCreateNewSpaceAsync()
          }}
          sx={{
            mt: 1,
            alignItems: 'flex-start',
          }}
        >
          <ListItemText
            primary={
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: '1rem',
                }}
              >
                +&nbsp;&nbsp;&nbsp;New space
              </Typography>
            }
          />
        </ListItemButton>
      </List>

      <DefaultPopover {...{ anchorEl: anchorEl!, close: closePopover }}>
        <SpaceOptionsPopoverItems space={hoveredSpace!} canDelete={canDelete} />
      </DefaultPopover>
    </>
  )
}
